export default "__VITE_ASSET__a84c360c__"